import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ViewLeadPopupComponent } from '../view-lead-popup/view-lead-popup.component';
import { Router } from '@angular/router';
import { statuses, oppStatus } from 'src/app/common/events/status.service';
@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.css']
})
export class SalesComponent implements OnInit {
  logsType: string = 'leadLogs';
  expandedRow: number | null = null;
  expandedIndex: number | null = null;
  childData: any;
  staffName: string = '0';
  type: any;
  allStaffRecords: any;
   statusList: any = statuses
   oppStatusList:any = oppStatus
  serviceType: string = '';
  selectedServiceType: string = '';
  statusType: string = 'interested';
  status: number = 5;
  userTypeName: string = '';
  leads: Array<any> = []
  assignedStaff: string = ''
  actualRemarks = [];
  realestateRemarks = [
    "Site Visit done",
    "Negotiation stage",
    "Discussion Stage",
    "Soft Approval Received",
    "Contract & Details sent"
  ]
  fintechRemarks = [
    "Application Filed",
    "Credit Check Completed",
    "Customer Docs Received",
    "Application Filed",
    "Credit Check Completed"
  ]
  propServicesRemarks = [
    "Site Visit Done",
    "Proposal Shared",
    "Negotiation Stage",
    "Catelouge Shared",
    "Models Finalised"
  ]
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    public lookupModel: RsbLookupModel,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.serviceType = this.lookupModel.getSelectedServiceType() ? this.lookupModel.getSelectedServiceType() : 'realEstate';
    this.type = this.lookupModel.getLoggedUser().type ? this.lookupModel.getLoggedUser().type : 'subFranchise';
    this.selectedServiceType = this.serviceType
    this.typeServices(6, this.serviceType)
    this.assignedStaff = 'myself'
    this.getStaff()
  }
  getStaff(): void {
    this.rsbService.getStaffDataWithoutPagination(this.type === 'franchise' ? 'staff' : 'subStaff').subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }
  selectStaff(event: any) {
    this.staffName = event.target.value
    if (event.target.value !== '0') {
      this.typeServices(this.status, this.serviceType, this.staffName)
    } else {
      this.typeServices(this.status, this.serviceType)
    }
  }
  getLeads(type: string): void {
    this.statusType = type;
    this.typeServices(this.status, this.serviceType);
  }
  typeServices(status: number, serType: string, id?: string): void {
    this.serviceType = serType;
    if (serType === 'realEstate') {
      this.actualRemarks = this.realestateRemarks
      this.rsbService.getSalesLeadsForFranchise({ "status": 7 }, id).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else if (serType === 'finTech') {
      this.actualRemarks = this.fintechRemarks
      this.rsbService.getAssignedFintechLeadsForFranchise({ "status": status }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else if (serType === 'propService') {
      this.actualRemarks = this.propServicesRemarks
      this.rsbService.getAssignedPropServiceLeadsForFranchise({ "status": status }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else {
      alert('Something went wrong');
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Verified Lead':
        return 'status-verified';
      case 'Qualified Lead':
        return 'status-qualified';
      default:
        return 'status-default';
    }
  }

  changeLogsType(type: string, index:number): void {
    this.logsType = type
    this.toggleRowForChange(index)
  }

   getStatusName(value: number): string {
    const status = this.statusList.find(s => s.value === value);
    return status ? status.name : '';
  }

     getOppStatusName(value: number): string {
    const status = this.oppStatusList.find(s => s.value === value);
    return status ? status.name : '';
  }



  getLeadTypeClass(type: string): string {
    switch (type) {
      case 'Online':
      case 'online':
        return 'lead-online';
      case 'Walkin':
        return 'lead-walkin';
      case 'Referral':
        return 'lead-referral';
      default:
        return 'lead-default';
    }
  }

  getCategoryClass(category: string): string {
    switch (category) {
      case 'Sale':
        return 'category-sale';
      case 'Rent':
        return 'category-rent';
      case 'Loans':
      case 'loans':
        return 'cat-loan';
      case 'Housing':
        return 'category-housing';
      case 'creditCard':
        return 'cat-credit-card'
      default:
        return 'category-default';
    }
  }

  getProductClass(product: string): string {
    switch (product) {
      case 'Villa':
        return 'product-villa';
      case 'Apartment':
        return 'product-apartment';
      case 'Land':
        return 'product-land';
      case 'Flat':
        return 'product-flat';
      case 'Plot':
        return 'product-plot';
      case 'Housing':
        return 'product-housing'; // Add this line
      case 'eduloan':
      case 'Edu Loan':
        return 'product-edu-loan'; // Add this line
      case 'Home Loan':
        return 'home-loan';
      case 'LAP':
        return 'laploan'; // Add this line
      case 'Personal/Self':
        return 'personalloan'; // Add this line
      case 'CCTV':
        return 'cctv'; // Add this line
      case 'Interior':
        return 'interior'; // Add this line
      case 'Furniture':
        return 'furniture'; // Add this line
      case 'Packers And Movers':
        return 'packers'; // Add this line

      default:
        return 'product-default';
    }
  }
  selectService(service: string) {
    this.selectedServiceType = service;
    this.serviceType = service;
    this.lookupModel.setSelectedServiceType(this.serviceType);
    //this.typeServices(this.lookupModel.getLoggedUser().type, service);
    this.typeServices(this.status, service);
  }

  assignedFunctionStaff(service: string) {
    this.assignedStaff = service
  }

  view(leads: any): void {
    const modalRef = this.modalService.open(ViewLeadPopupComponent);
    modalRef.componentInstance.leadStatus = leads.status
    modalRef.result.then((result) => {
      let payload = {}
      result.status = Number(result.status);
      payload = {
        id: this.lookupModel.getLoggedUser().franchiseId,
        status: result.status,
        leadId: leads.leadId,
        propertyId: leads.propertyId,
        description: result.remarks,
        propType: this.serviceType,
        productValue: leads.productValue,
        actualCost: result.actualProductCost
      }
      this.rsbService.convertToSales(payload).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.router.navigate(['sales'])
          //this.followupRedirectedMethod(result)
        }
      })


    })
  }

  redirectMethod(result: any): void {
    if (result.status == "4") {
      this.router.navigate(['Leads']);
    } else if (result.status == "5") {
      this.router.navigate(['Leads']);
    } else {
      this.router.navigate(['organizedLeads']);
    }
  }

  followupRedirectedMethod(result: any): void {
    const inputDate = new Date(result.date);
    const today = new Date();

    // Normalize both dates to remove time components for accurate comparison
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      this.router.navigate(['FollowUp']); // Date is in the future
    } else if (inputDate < today) {
      this.router.navigate(['FollowUp']); // Date is in the past
    } else {
      this.router.navigate(['FollowUp']); // Date is today
    }
  }

  toggleRowForChange(index: number) {
    if (this.logsType === 'leadLogs') {
      this.rsbService.getFranchiseLogs({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, leadId: this.leads[index].leadId }).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
        }
      })
    } else if (this.logsType === 'followupLogs') {
      this.rsbService.getFollowupDetailsOfLead(this.leads[index].leadId).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
        }
      })
    } else {
         this.rsbService.getOppFranchiseLogs({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, leadId: this.leads[index].leadId }).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
        }
      })
    }
  }

  toggleRow(index: number) {
    if (this.logsType === 'leadLogs') {
      this.rsbService.getFranchiseLogs({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, leadId: this.leads[index].leadId }).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
          this.expandedIndex = this.expandedIndex === index ? null : index;
        }
      })
    } else if (this.logsType === 'followupLogs') {
      this.rsbService.getFollowupDetailsOfLead(this.leads[index].leadId).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
          this.expandedIndex = this.expandedIndex === index ? null : index;
        }
      })
    } else {
         this.rsbService.getOppFranchiseLogs({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, leadId: this.leads[index].leadId }).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
          this.expandedIndex = this.expandedIndex === index ? null : index;
        }
      })
    }
  }


}


